module.exports = __webpack_public_path__ + "img/Stakeholders-Stakeholder engagement.85ee0f87.svg";